import _ from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getContainerWidth } from 'utils/helperMethods';

//stores the width of the container so that it can be used to style graphs
export const useContainerWidth = ({ containerId, buffer = 40 }: { containerId: string; buffer?: number }) => {
    const containerWidthRef = useRef<any>(0);
    if (!containerWidthRef.current) {
        const containerWidth = getContainerWidth(containerId, buffer);
        containerWidthRef.current = containerWidth;
    }
    return containerWidthRef.current;
};

// function parseLocalStorageItem(id: string) {
//     const parsedItem = JSON.parse(localStorage.getItem('container-width') || '{}');
//     if (typeof parsedItem === 'object' && id in parsedItem) return Number(parsedItem[id]);
//     return 0;
// }

// function fetchLocalStorageItem() {
//     const parsedItem = JSON.parse(localStorage.getItem('container-width') || '{}');
//     return typeof parsedItem === 'object' ? parsedItem : {};
// }

// //stores the width of the container so that it can be used to style graphs
// export const useContainerWidth = ({ containerId }: { containerId: string }) => {
//     //debounce resize function
//     const debounceFn = useCallback(_.debounce(handleResize, 300), []);
//     const [containerWidth, setContainerWidth] = useState(debounceFn() || 0);

//     //function called when resize event happens
//     function handleResize() {
//         const width = getContainerWidth(containerId);
//         setContainerWidth(width || 0);
//         const parsedLocalStorageItem = fetchLocalStorageItem();
//         parsedLocalStorageItem[containerId] = width;
//         // localStorage.setItem('container-width', JSON.stringify(parsedLocalStorageItem));
//     }

//     useEffect(() => {
//         // if (!containerWidth) debounceFn();
//         window.addEventListener('resize', debounceFn);
//         return () => {
//             window.removeEventListener('resize', debounceFn);
//         };
//     }, []);
//     return containerWidth;
// };
